'use strict';

(function (angular) {

    angular.module('zp').factory('NewsModel', newsModelFactory);

    /**ngInject */
    function newsModelFactory() {

        function NewsModel(data) {

            this.title = data && data.title ? data.title : '';
            this.description = data && data.description ? data.description : '';
            this.author = data && data.author ? data.author : '';
            this.date = data && data.date ? new Date(data.date) : new Date();
            this.image = data && data.image ? data.image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSenMve532bF8SrIt0779nbGpSk7fLAAmB062QRzEITw2rd5ofH';
            this.shares = data && data.shares ? data.shares : 0;
            this.likes = data && data.likes ? data.likes : 0;
            this.comments = data && data.comments ? data.comments : 0;
        }

        return NewsModel;
    }
})(window.angular);